import { render, staticRenderFns } from "./package.vue?vue&type=template&id=2a25922c&scoped=true"
import script from "./package.vue?vue&type=script&setup=true&lang=js"
export * from "./package.vue?vue&type=script&setup=true&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=2a25922c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25922c",
  null
  
)

export default component.exports